import BaseComponent from '../../components/base-component/base-component'
import { bodyElement } from '../../components/common/body-element'
import Preloader from '../../components/common/preloader'
import { parseHTML } from '../../utils/dom'

class Shop extends BaseComponent {
  cache: object
  searchParamsInitial: string
  searchParamsPrev: string
  sortQuery: string
  filterQuery: string

  constructor() {
    super()

    this.cache = {}

    this.searchParamsInitial = window.location.search.slice(1)
    this.searchParamsPrev = window.location.search.slice(1)

    this.sortQuery = ''
    this.filterQuery = ''
  }

  connectedCallback(): void {
    window.addEventListener('popstate', this.handleHistoryChange)
  }

  disconnectedCallback(): void {
    window.removeEventListener('popstate', this.handleHistoryChange)
  }

  handleHistoryChange = ({ state: { searchParams } }): void => {
    const newSearchParams = searchParams || this.searchParamsInitial

    if (newSearchParams !== this.searchParamsPrev) {
      this.updateBySearchParams(newSearchParams)
    }
  }

  formatParams(searchParams): string {
    this.searchParamsPrev = searchParams

    const baseParams = this.dataset.baseParams || ''

    return `${baseParams}${searchParams}`
  }

  updateBySearchParams(searchParams): void {
    this.updateShopBySearchParams(searchParams)
    this.updateFiltersBySearchParams(searchParams)
  }

  updateShopBySearchParams(searchParams): void {
    const url = this.createUrl(searchParams)

    this.cache[url]
      ? this.updateElements(this.cache[url])
      : this.getFromUrl(url).then(html => this.updateElements(html))

    this.updateURL(searchParams, url)
  }

  updateFiltersBySearchParams(searchParams): void {
    const url = this.createUrl(searchParams)

    const mobileFilter = document.querySelector('#SidebarFiltersMobile')
    const desktopFilter = document.querySelector('#SidebarFiltersDesktop')

    if (mobileFilter && desktopFilter) {
      const filters = [mobileFilter, desktopFilter]

      filters.forEach(filter => {
        filter.loadingOverlay.show()
      })

      const updateFilters = html => {
        filters.forEach(filter => {
          filter.updateHTML(html)

          filter.loadingOverlay.hide()
        })
      }

      this.cache[url]
        ? updateFilters(this.cache[url])
        : this.getFromUrl(url).then(html => updateFilters(html))
    }
  }

  getFromUrl(url) {
    const loadingOverlayElement = this.querySelector<HTMLElement>(
      '#ShopProductsOverlay',
    )
    const loadingOverlay = loadingOverlayElement
      ? new Preloader(loadingOverlayElement)
      : null

    if (loadingOverlay) {
      loadingOverlay.show()
    }

    const preparedUrl = `${url}&section_id=${this.dataset.sectionId}`

    return fetch(preparedUrl)
      .then(response => response.text())
      .then(responseText => {
        const html = parseHTML(responseText)

        this.cache[url] = html

        if (loadingOverlay) {
          loadingOverlay.hide()
        }

        return html
      })
      .catch(() => {
        if (!bodyElement.notification) {
          return
        }

        bodyElement.notification.show('Error in shop component', 'warning')
      })
  }

  updateURL(searchParams, url): void {
    history.pushState({ searchParams }, '', url)
  }

  createUrl(searchParams): string {
    const params = this.formatParams(searchParams) || ''
    const url = `${window.location.pathname}?${params}`

    return url
  }

  updateElements(html): void {
    const elements = [
      'ShopProducts',
      'ShopProductCount',
      'ShopSortList',
      'ShopActiveFilters',
    ]

    elements.forEach(elementId => {
      const element = document.getElementById(elementId)
      const newElement = html.getElementById(elementId)

      if (element && newElement) {
        const clonedNewElement = newElement.cloneNode(true)

        element.replaceChildren(...clonedNewElement.childNodes)
      }
    })
  }

  resetQueries(): void {
    this.sortQuery = ''
    this.filterQuery = ''
  }
}

export default Shop
